export default __webpack_public_path__ + "static/media/interpreting_3.4f60624f.jpg";